import { render, staticRenderFns } from "./canvasWrap.vue?vue&type=template&id=77344947&scoped=true"
import script from "./canvasWrap.vue?vue&type=script&lang=js"
export * from "./canvasWrap.vue?vue&type=script&lang=js"
import style0 from "./canvasWrap.vue?vue&type=style&index=0&id=77344947&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77344947",
  null
  
)

export default component.exports